import templateUrl from "emun.promotion/promo-sheet/promo-sheet-manager.htm";
import controller from "emun.promotion/promo-sheet/promo-sheet-manager.controller";

export default {
  bindings: {},
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
